import React from "react";
import PropTypes from "prop-types";
import { Breadcrumbs, Typography } from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import { MARKET_BRAND_ROUTE_PATTERN } from "../../../utils/marketBrandUtils";

const marketBrandPattern = new RegExp(`^(${MARKET_BRAND_ROUTE_PATTERN})$`);

const capitalizeFirstLetter = (string) => {
  const stringWithoutHyphens = string.replace(/-/g, " ");
  return stringWithoutHyphens
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const EMPBreadcrumbs = ({ t, customerHandlingLabel }) => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter((path) => path);
  const hasMarketBrand = marketBrandPattern.test(segments[0]);
  const prefix = hasMarketBrand ? `/${segments[0]}` : "";
  const pathNames = hasMarketBrand ? segments.slice(1) : segments;
  const dashboardPath = `${prefix}/dashboard`;
  const translate = (key, fallback) => {
    const value = t?.(key);
    return value && value !== key ? value : fallback;
  };

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link to={dashboardPath}>
        {translate("GlobalNavBar.dashboard", "Dashboard")}
      </Link>
      {pathNames.map((link, index) => {
        const isLastItem = index === pathNames.length - 1;
        const href = `${prefix}/${pathNames.slice(0, index + 1).join("/")}`;
        const displayText =
          link === "customer-handling"
            ? customerHandlingLabel ||
              translate(
                "GlobalNavBar.customerHandling",
                capitalizeFirstLetter(link)
              )
            : link === "dashboard"
              ? translate("GlobalNavBar.dashboard", "Dashboard")
              : /\d/.test(link)
                ? link
                : capitalizeFirstLetter(link);
        return isLastItem ? (
          <Typography variant="body2" key={displayText}>
            {displayText}
          </Typography>
        ) : (
          <Link to={href} key={displayText}>
            {displayText}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

EMPBreadcrumbs.propTypes = {
  customerHandlingLabel: PropTypes.string,
  t: PropTypes.func,
};

export default EMPBreadcrumbs;
